// Cache HTMLImageElements keyed by URL so a segment used in multiple
// layers loads its PNG only once.

const cache = new Map();

export function loadImage(url) {
  if (cache.has(url)) return cache.get(url);
  const promise = new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => resolve(img);
    img.onerror = () => {
      // Surface but keep the cache entry rejected so retries don't spam.
      reject(new Error(`Failed to load ${url}`));
    };
    img.src = url;
  });
  cache.set(url, promise);
  return promise;
}

export async function loadImages(urls) {
  return Promise.all(urls.map((u) => loadImage(u)));
}
